import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class AuthDataService {

    constructor(private http: HttpClient) {
    }

    get_data(consumer_name: string, token: string, credential_username: string) {
        let headers: HttpHeaders = new HttpHeaders({
            "Accept": "application/json",
            "Authorization": "Bearer " + token,
            "X-Dashboard-Account": consumer_name,
            "X-Caligoo-Username": credential_username
        });

        return this.http.get('https://services.caligoo.com/settings', { headers: headers, withCredentials: true })
            .pipe(map((settings: any) => {
                if (settings) {
                    localStorage.setItem('currentSettings', JSON.stringify(settings));
                    var accounts = settings.find((o) => { return o.name === 'accounts'; });
                    if (accounts !== undefined) {
                        localStorage.setItem('currentAccounts', accounts.value);
                    }
                }
            }), catchError(this.handleError));
    }

    private handleError(error: any) {
        return throwError(() => error || 'Server Error');
    }
}
